//Global Ajax Complete

class XhrClass {
    static patch() {
        let $forms = $('.hubspot-form');

        $forms.each((i, form) => {
            $(form).find("[placeholder$='*']").each((i, field) => {
                let placeholder = $(field).attr('placeholder')
                    .replace(/([a-z])\*\*$/gi, '$1*');

                $(field).attr('placeholder', placeholder)
            });

            $(form).find("option:first-child").each((i, option) => {

                let text = $(option).text()
                    .replace(/([a-z])\*\*$/gi, '$1*');

                $(option).text(text)
            });
        });
    }
}

XhrClass.patch();

setTimeout(() => {
    XhrClass.patch();
}, 1000);

$(document).ready(() => {
    $("body").bind("ajaxComplete", (e, xhr, settings) => {
        XhrClass.patch();
    });
});


